import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { appNavigationConfig } from '../../config/app-navigation.config';

@Component({
  selector: 'app-sidebar',
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './app-sidebar.html',
  styleUrl: './app-sidebar.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppSidebar {
  protected readonly navigationGroups = appNavigationConfig;
  readonly collapsed = input(false);
  readonly mobileOpen = input(false);
  readonly isMobile = input(false);
}

